import React, { useState } from 'react';
import {
  Grid,
  makeStyles,
  IconButton,
  Paper,
  InputBase,
} from '@material-ui/core';
import { Search, Close } from '@material-ui/icons';

import SearchMessage from './SearchMessage';

const useStyle = makeStyles((theme) => ({
  hero: {
    width: '100%',
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
  },
  searchInput: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: "98%",
    maxWidth: 720,
    borderRadius: 6,
  },
  input: {
    // marginLeft: theme.spacing(1),
    marginLeft: 2,
    flex: 1,
    paddingLeft: 2,
  },
  iconButton: {
    padding: 5,
  },
  closeButton: {
    padding: 5,
    display: "none",
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

const HeroSearch = (props) => {
  const { setSearchText, setCloseSearch, setLoading } = props;

  const [errorMessage, setErrorMessage] = useState(false);
  const [warningMessage, setWarningMessage] = useState(false);

  const classes = useStyle();

  const handleErrorMessage = () => {
    setErrorMessage(!errorMessage);
  };

  const handleWarningMessage = () => {
    setWarningMessage(!warningMessage);
  };

  const inputValidation = () => {
    const inputValue = document.getElementById('input-search').value.trim();

    if (inputValue !== '') {
      return inputValue;
    } else {
      return false;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const inputValue = inputValidation();
    if (inputValue) {
      const input = document.getElementById('input-search');
      input.blur();

      setLoading(true);
      setSearchText(inputValue);
    } else {
      setErrorMessage(true);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    let closeButton = document.getElementById('close-button');

    closeButton.style.display = "block";
  }

  const handleClose = (e) => {
    e.preventDefault();

    const input = document.getElementById('input-search');
    input.value = "";
    input.blur();

    let closeButton = document.getElementById('close-button');
    closeButton.style.display = "none";

    setLoading(true);
    setCloseSearch(true);
  }

  return (
    <Grid
      container
      className={classes.hero}
      alignContent="center"
      justify="center"
    >
      <Grid container>
        <Grid item xs={12} className={classes.inputContainer}>
          <Paper
            variant="outlined"
            elevation={2}
            component="form"
            className={classes.searchInput}
            onSubmit={(e) => handleSubmit(e)}
            onChange={(e) => handleChange(e)}
          >
            <IconButton
              className={classes.iconButton}
              onClick={(e) => handleSubmit(e)}
            >
              <Search />
            </IconButton>
            <InputBase
              placeholder="Search products, brands or stores"
              id="input-search"
              className={classes.input}
            />
            {/* <Divider className={classes.divider} orientation="vertical" /> */}
            <IconButton
              className={classes.closeButton}
              id="close-button"
              onClick={(e) => handleClose(e)}
            >
              <Close />
            </IconButton>
          </Paper>
        </Grid>
      </Grid>
      <SearchMessage
        severity="error"
        open={errorMessage}
        handleClose={handleErrorMessage}
        message="Search input is empty. Try again."
      />
      <SearchMessage
        severity="warning"
        open={warningMessage}
        handleClose={handleWarningMessage}
      />
    </Grid>
  );
};

export default HeroSearch;
